import PropTypes from 'prop-types';
import React from 'react';
import {selectedOptionText} from 'utilities/DOM';
import fonts from 'utilities/fonts';

class CollapseSelect extends React.Component {
  select = null;

  componentDidMount() {
    this.scaleWidth();
    fonts.addEventListener('loadingdone', this.scaleWidth);
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (this.props.value !== next.value) {
      requestAnimationFrame(this.scaleWidth);
    }
  }

  componentWillUnmount() {
    fonts.removeEventListener('loadingdone', this.scaleWidth);
  }

  scaleWidth = () => {
    const select = this.select;
    const parent = select.parentNode;
    const text = selectedOptionText(select);
    const measureEl = document.createElement('select');
    const optionEl = document.createElement('option');
    optionEl.innerText = text;
    measureEl.className = select.className;
    measureEl.appendChild(optionEl);
    parent.appendChild(measureEl);
    const isVisible = measureEl.offsetWidth > 0;

    if (isVisible) {
      select.style.width = `${measureEl.offsetWidth}px`;
    }

    parent.removeChild(measureEl);
  };

  render() {
    return (
      <select {...this.props} ref={el => (this.select = el)}>
        {this.props.children}
      </select>
    );
  }
}

CollapseSelect.propTypes = {
  children: PropTypes.node,
};

export default CollapseSelect;
